import { createContext, ReactNode, useContext, useState } from "react";

interface DrawerContextType {
  isExpanded: boolean;
  toggleDrawer: () => void;
  closeDrawer: () => void;
}

const DrawerContext = createContext<DrawerContextType | undefined>(undefined);

export const DrawerProvider = ({ children }: { children: ReactNode }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleDrawer = () => {
    setIsExpanded((prev) => !prev);
  };

  const closeDrawer = () => {
    setIsExpanded(false);
  };

  return (
    <DrawerContext.Provider value={{ isExpanded, toggleDrawer, closeDrawer }}>
      {children}
    </DrawerContext.Provider>
  );
};

export const useDrawer = () => {
  const context = useContext(DrawerContext);
  if (!context) {
    throw new Error("useDrawer must be used within a DrawerProvider");
  }
  return context;
};
